import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CommonUtilityService } from '@app/services/common-utility.service';
import { ToastService } from '@app/shared/service/toast.service';
import { environment } from '@env/environment';
import { CardTypePipe } from '@upr-web-primer/card-types';
import { DalService } from '@upr-web-primer/dal';
import { MsGuestsService } from '@upr-web-primer/ms-guests';
import { NotificationService } from '@upr-web-primer/notification';
import { LocalStorageService } from '@upr-web-primer/storage';
import { get } from 'lodash-es';
import { CookieService } from 'ngx-cookie-service';
import { CreditCardTypes } from '../../account/order-history/creditcardtypes';

@Component({
  selector: 'app-add-payment-info',
  templateUrl: './add-payment-info.component.html',
  styleUrls: ['./add-payment-info.component.scss'],
})
export class AddPaymentInfoComponent implements OnInit {
  editPaymentInfoForm: FormGroup;
  yearOptions: any[] = [];
  monthOptions: any[] = [];
  pageLabels: any;
  cardType: any;
  cardNumber: any;
  errorCardNumber = '';
  errorYear = '';
  errorMonth = '';
  errorSecurityCode = '';
  setCardType = '';
  existingCardTypes = CreditCardTypes;
  selectedMonth: any;
  selectedYear: any;
  securityCode: any;
  cardObject: any;
  enableSave = false;
  primaryVal = false;
  primaryValueChanged = false;
  selectedAddress: any;

  constructor(
    public commonUtilityService: CommonUtilityService,
    @Inject('AppRoutes') public appRoutes: any,
    @Inject('GlobalDefaults') public globalDefault: any,
    @Inject('RelativeUrls') private relativeUrls: any,
    @Inject('AppDefaults') public appDefault: any,
    @Inject('CardTypes') public cardTypes: any,
    @Inject('MiscPattern') public miscPattern: any,
    @Inject('DefaultValues') public defaultValues: any,
    public cookieService: CookieService,
    public guestsService: MsGuestsService,
    public notification: NotificationService,
    public cdr: ChangeDetectorRef,
    public toastService: ToastService,
    @Inject('sourceKeys') public sourceKeys: any,
    private formBuilder: FormBuilder,
    public cardTypePipe: CardTypePipe,
    public httpClient: HttpClient,
    public dal: DalService,
    public localStorage: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.pageLabels = this.commonUtilityService?.getResolvedPageData();
    if (this.commonUtilityService.tempPaymentInfo) {
      this.fillTempCardDetails();
    }
    this.generateYearOptions();
    this.generateMonthOptions();
    this.createForm();
    this.setFormValues();
    this.enableButton();
  }

  /**
   * loadUserInfo-It will go back to My_Profile Page
   */

  bacToAccInfo(): void {
    this.commonUtilityService.tempPaymentInfo = {};
    this.commonUtilityService?.changeRoute(this.appRoutes.MY_PROFILE);
  }
  /**
   * onPrimaryClick-It will set the primary Address
   */

  onPrimaryClick(event: any): void {
    if (event?.target?.id) {
      if (event?.target?.id === 'primary') {
        const currentValue = event?.detail === 'checked' ? true : false;
        this.editPaymentInfoForm?.patchValue({
          primary: currentValue,
        });
      }
    }
  }
  /**
   * createForm - it will create the form with input fields
   */

  createForm(): any {
    this.editPaymentInfoForm = this.formBuilder.group({
      primary: new FormControl(),
    });
  }

  /**
   * setFormValues - set and patch the form values
   */

  setFormValues(): void {
    this.editPaymentInfoForm?.patchValue({
      primary: false,
    });
  }
  /**
   * enableButton-It will use when user changes previous value
   */

  enableButton(): any {
    this.editPaymentInfoForm.valueChanges.subscribe((currentValue) => {
      if (currentValue?.primary === this.primaryVal) {
        this.primaryValueChanged = false;
      } else {
        this.primaryValueChanged = true;
        this.validateContinueEnabler();
      }
    });
  }

  onSave(): void {
    const guestId = this.guestsService.helper.getGuestId();
    const url = this.getRelativeUrls(
      this.relativeUrls.GET_PAYMENT_INFO,
      guestId
    );
    const requestBody = {
      billing_address: {
        address_id: this.selectedAddress?.address_id,
        address_line1: this.selectedAddress?.address_line1,
        address_line2: this.selectedAddress?.address_line2,
        city: this.selectedAddress?.city,
        state: this.selectedAddress?.state,
        postal_code: this.selectedAddress?.postal_code,
        country_code: this.selectedAddress?.country_code,
      },
      expiration: {
        month: +this.cardObject.expire.slice(-2),
        year: +this.cardObject.expire.slice(0, 4),
      },
      is_primary: get(this.editPaymentInfoForm, 'value.primary', ''),
      first_name_on_card: this.selectedAddress?.first_name,
      last_name_on_card: this.selectedAddress?.last_name,
      number: this.cardObject.cardno,
      cvv: this.cardObject.securitycode,
    };
    const xSourceId = this.commonUtilityService?.getSourceId(
      this.sourceKeys?.WEB_USH_CARD
    );
    const xInstanceId = this.localStorage.getItem('x-instance-id');
    const headers = new HttpHeaders()
      .append('x-instance-id', xInstanceId)
      .append('x-source-id', xSourceId)
      .append(
        'x-uniwebservice-apikey',
        this.defaultValues.UNIWebService_xApiKey
      )
      .append('guest-id', guestId)
      .append('x-resort-area-code', this.appDefault.RESORT_AREA_CODE);

    this.dal
      .httpRequest(url, this.appDefault.POST, requestBody, headers)
      .then(() => {
        this.toastService.show({
          text: this.pageLabels?.['paymentInfo.addSnack'],
          type: this.globalDefault?.SUCCESS,
        });
        this.commonUtilityService.tempPaymentInfo = {};
        this.commonUtilityService?.changeRoute(this.appRoutes.PAYMENT_INFO);
      })
      .catch((error) => {
        if (error.status == this.globalDefault.ERROR_401) {
          this.commonUtilityService.setUser();
          localStorage.clear();
          sessionStorage.clear();
          this.cookieService.deleteAll('/', environment.cookieSubDomain);
          const redirectUrl = this.commonUtilityService.getOidcRedirectionUrl();
          this.commonUtilityService.redirectToOidcAppEndSession(redirectUrl);
        } else {
          this.notification?.show(error?.error?.message);
          this.commonUtilityService.eventDDlTrigger(error?.error?.message);
        }
      });
  }

  public getRelativeUrls(url: string, guestId: string): string {
    return url.replace('{guest_id}', guestId);
  }

  fillTempCardDetails(): void {
    this.cardNumber = this.commonUtilityService.tempPaymentInfo?.cardNumber;
    this.selectedMonth = parseInt(
      this.commonUtilityService.tempPaymentInfo?.expiryMonth
    );
    this.selectedYear = parseInt(
      this.commonUtilityService.tempPaymentInfo?.expiryYear
    );
    this.securityCode = this.commonUtilityService.tempPaymentInfo?.securitycode;
    this.primaryVal = this.commonUtilityService.tempPaymentInfo?.primaryVal;
    this.editPaymentInfoForm?.patchValue({
      primary: this.primaryVal,
    });
  }

  onCreditCardValueChange(event: any): void {
    if (event?.detail?.cardNumber) {
      this.cardNumber = event?.detail?.cardNumber;
      this.cardType = this.cardTypePipe.transform(this.cardNumber);
      if (!this.cardType) {
        this.setCardType = '';
      } else {
        this.existingCardTypes.forEach((type) => {
          if (this.cardType === type[0]) {
            this.setCardType = type[1];
            this.errorCardNumber = '';
          }
        });
      }
    }
    if (event?.detail?.month) {
      this.selectedMonth = event?.detail?.month;
    }
    if (event?.detail?.year) {
      this.selectedYear = event?.detail?.year;
    }
    if (event?.detail?.securityCode) {
      this.securityCode = event?.detail?.securityCode;
    }
    const decimalPattern = this.miscPattern.DECIMAL;

    if (this.securityCode) {
      if (
        this.cardType === this.cardTypes.AX &&
        this.securityCode.length !== 4
      ) {
        this.errorSecurityCode =
          this.pageLabels?.['paymentInfo.error.requireFourDigits'];
      } else if (
        this.cardType !== this.cardTypes.AX &&
        this.securityCode.length !== 3
      ) {
        this.errorSecurityCode =
          this.pageLabels?.['paymentInfo.error.requireThreeDigits'];
      } else if (
        this.securityCode % 1 !== 0 ||
        decimalPattern.test(this.securityCode)
      ) {
        this.errorSecurityCode =
          this.pageLabels?.['paymentInfo.error.invalidSecurityCode'];
      } else {
        this.errorSecurityCode = '';
      }
    }
    this.validateMonthAndYear();
    this.validateContinueEnabler();
  }

  validateMonthAndYear(): void {
    const dateObj = new Date();
    const currentMonth = dateObj.getMonth() + 1;
    const currentYear = dateObj.getFullYear();

    if (this.selectedYear && currentYear > this.selectedYear) {
      this.errorYear = this.pageLabels?.['paymentInfo.error.invalidYear'];
    } else if (
      currentYear === parseInt(this.selectedYear) &&
      currentMonth > parseInt(this.selectedMonth)
    ) {
      this.errorMonth = this.pageLabels?.['paymentInfo.error.invalidMonth'];
      this.errorYear = '';
    } else {
      this.errorMonth = '';
      this.errorYear = '';
    }
  }

  validateContinueEnabler(): void {
    const errors =
      this.errorCardNumber ||
      this.errorMonth ||
      this.errorYear ||
      this.errorSecurityCode;
    const containsData =
      this.cardNumber &&
      this.selectedMonth &&
      this.selectedYear &&
      this.securityCode;
    if (containsData && errors == '') {
      this.enableSave = true;
      if (
        this.selectedMonth?.toString().length < 2 &&
        this.selectedMonth < 10
      ) {
        this.selectedMonth = '0' + this.selectedMonth;
      }
      const expiryDate = `${this.selectedYear}${this.selectedMonth}`;
      this.cardObject = {
        cardno: this.cardNumber,
        expire: expiryDate,
        securitycode: this.securityCode,
      };
    } else {
      this.enableSave = false;
    }
  }

  generateYearOptions(): void {
    const currentYear = new Date().getFullYear();
    const currentYearLabel = parseInt(
      new Date().getFullYear().toString().substring(2)
    );
    let total = 15,
      i = 0;
    while (total > 0) {
      this.yearOptions.push({
        label: currentYearLabel + i,
        value: currentYear + i,
      });
      i += 1;
      total -= 1;
    }
  }
  generateMonthOptions(): void {
    let startMonth = 1;
    let total = 12;
    while (total > 0) {
      if (total > 3) {
        this.monthOptions.push({
          label: '0' + startMonth,
          value: startMonth,
        });
      } else {
        this.monthOptions.push({
          label: startMonth,
          value: startMonth,
        });
      }
      startMonth += 1;
      total -= 1;
    }
  }

  onCreditCardBlurChange(event: any): void {
    if (event?.detail === 'cardNumber') {
      this.cardType = this.cardTypePipe.transform(this.cardNumber);
      if (!this.cardType) {
        this.errorCardNumber =
          this.pageLabels?.['paymentInfo.error.invalidCardNumber'];
        this.enableSave = false;
      } else {
        this.validateContinueEnabler();
      }
    }
  }

  setAddress(data: any): void {
    this.commonUtilityService.tempPaymentInfo = {
      cardNumber: this.cardNumber,
      expiryMonth: this.selectedMonth,
      expiryYear: this.selectedYear,
      securitycode: this.securityCode,
      primaryVal: this.editPaymentInfoForm?.controls['primary']?.value,
    };
    this.selectedAddress = data;
  }
}
